export default `/* Ids Splitter Pane Component */
:host([container-queries]) {
  container-type: inline-size;
}

.ids-splitter-pane {
  overflow: auto;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

/* Padding */
:host([padding=xs]) .ids-splitter-pane {
  padding: var(--ids-space-08);
}

:host([padding=sm]) .ids-splitter-pane {
  padding: var(--ids-space-16);
}

:host([padding=md]) .ids-splitter-pane {
  padding: var(--ids-space-20);
}

:host([padding=lg]) .ids-splitter-pane {
  padding: var(--ids-space-24);
}

:host([padding=xl]) .ids-splitter-pane {
  padding: var(--ids-space-32);
}

/* Padding X */
:host([padding-x=xs]) .ids-splitter-pane {
  padding-inline: var(--ids-space-08);
}

:host([padding-x=sm]) .ids-splitter-pane {
  padding-inline: var(--ids-space-16);
}

:host([padding-x=md]) .ids-splitter-pane {
  padding-inline: var(--ids-space-20);
}

:host([padding-x=lg]) .ids-splitter-pane {
  padding-inline: var(--ids-space-24);
}

:host([padding-x=xl]) .ids-splitter-pane {
  padding-inline: var(--ids-space-32);
}

/* Padding Y */
:host([padding-y=xs]) .ids-splitter-pane {
  padding-block: var(--ids-space-08);
}

:host([padding-y=sm]) .ids-splitter-pane {
  padding-block: var(--ids-space-16);
}

:host([padding-y=md]) .ids-splitter-pane {
  padding-block: var(--ids-space-20);
}

:host([padding-y=lg]) .ids-splitter-pane {
  padding-block: var(--ids-space-24);
}

:host([padding-y=xl]) .ids-splitter-pane {
  padding-block: var(--ids-space-32);
}

/* Hide content when collapsed */
:host([collapsed]) .ids-splitter-pane {
  padding: 0;
  display: none;
  overflow: hidden;
}

/* Remove all padding when pane is very small */
@container (max-width: 80px) {
  :host([padding]) .ids-splitter-pane,
  :host([padding-x]) .ids-splitter-pane {
    padding-inline: 0;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
